import EvaluationScope from './EvaluationScope';
import AbstractEvaluationScope from './AbstractEvaluationScope';

export default EvaluationScope;
export {
  AbstractEvaluationScope,
};
